/* eslint import/prefer-default-export: 0 */

export const identification = {
  pvq: {
    destination: {
      intro: 'Identification Intro',
      review: 'Review Identification',
      othernames: 'Additional Names',
      name: 'Full Name',
      birthdate: 'Date of Birth',
      birthplace: 'Place of Birth',
      contacts: 'Contact Information',
      ssn: 'U.S. Social Security Number',
    },
    intro: {
      title: 'Information about you',
      body:
        'The purpose of this section is to collect information from you that helps us verify your identity. We ask for your name, date of birth, place of birth, Social Security Number, and contact information. This helps make sure we only collect information that pertains to you.',
    },
    applicantName: {
      infoTitle: 'Provide your full name',
      info: [
        'This section asks for information regarding your full legal name. Your full legal name is usually the name you have on your most recently issued, unexpired government-issued picture identification. This is the name that identifies you for legal, administrative, and other official purposes, such as Social Security, census, taxes, and other official transactions or records.',
        '* If your name is one alpha character or a string of alpha characters (such as "Z" or "T.J.", where "T." and "J." are not initials for names), check the "Letter(s) Only" box.',
        '* If you do not have a middle name, check the "No Middle Name" box.',
        '* If you are a "Jr.," "Sr.," "II," "III", "IV," etc. enter this under Suffix.',
        '* If you have a hyphenated name, put the entire hyphenated name in the applicable block (for example, if your last name is "Smith-Jones", put "Smith-Jones" in the "Last Name" block.)',
        '* If you have two last names that are not hyphenated (such as Smith Jones), please enter them as separate words in the “Last Name” block.',
        '* If you only have one name, put it in the "Last Name" block and check the boxes "No First Name" and "No Middle Name".',
      ],
      title: 'What is your full name?',
      last: {
        help: {
          title: 'Enter a valid last name.',
          message:
            'Please enter your entire last name. If your name is one alpha character or a string of alpha characters (such as "Z" or "T.J.", where "T." and "J." are not initials for names), check the "Letter(s) Only" box.',
          note: '',
        },
      },
      first: {
        help: {
          title: 'Enter a valid first name.',
          message:
            'Please enter your entire first name. If your name is one alpha character or a string of alpha characters (such as "Z" or "T.J.", where "T." and "J." are not initials for names), check the "Letter(s) Only" box.',
          note: '',
        },
      },
      middle: {
        help: {
          title: 'Enter a valid middle name.',
          message: [
            'Please enter your entire middle name.',
            'If your name is one alpha character or a string of alpha characters (such as "Z" or "T.J.", where "T." and "J." are not initials for names), check the "Letter(s) Only" box.  If you do not have a middle name, check the "No Middle Name" box.',
          ],
          note: '',
        },
      },
      suffix: {
        help: {
          title: 'Use "Other" if your suffix isn\'t listed',
          message:
            'If the suffix does not appear in this list, select "Other" and enter the suffix in the provided field.',
          note: '',
        },
      },
    },
    birthdate: {
      title: 'What is your date of birth?',
      confirmation: 'I confirm this date is correct',
      info: [
        'This section asks for information regarding your date of birth. If you do not know your date of birth, put the date of birth you have been using on official documents, check the \'Estimated\' box, and provide an explanation.',
      ],
      help: {
        title: 'Check "Estimated" if date of birth is unknown',
        message:
          'If you do not know your date of birth, put the date of birth you have been using on official documents, check the \'Estimated\' box, and provide an explanation.',
        note: '',
      },
    },
    birthplace: {
      title: 'Were you born in the U.S.?',
      info: 'This section asks for information regarding your place of birth. The United States (U.S.) is defined as the 50 U.S. states, the District of Columbia, and the U.S. territories.',
      question: {
        label: 'Were you born in the United States of America?',
        yes: 'Yes',
        no: 'No',
      },
      branch: {
        help: {
          title: 'This is your physical place of birth',
          message:
            'Example: United States citizens born in another country would list that other country.',
          note: '',
        },
      },
      help: {
        city: {
          title: 'Need help with the city?',
          message: 'City where you were born',
          note: '',
        },
        state: {
          title: 'Need help with the state?',
          message: 'State where you were born',
          note: '',
        },
        country: {
          title: 'Need help with the country?',
          message: 'Country where you were born',
          note: '',
        },
        county: {
          title: 'Need help with the county?',
          message: 'County where you were born',
          note: '',
        },
      },
      mothersName: {
        last: {
          help: {
            title: 'Enter a valid last name.',
            message: 'Please enter your entire last name.',
            note: '',
          },
        },
        first: {
          help: {
            title: 'Enter a valid first name.',
            message: 'Please enter your entire first name.',
            note: '',
          },
        },
        middle: {
          help: {
            title: 'Enter a valid middle name.',
            message: 'Please enter your entire middle name.',
            note: '',
          },
        },
      },
      label: {
        state: 'State or Territory',
        city: 'City',
        county: 'County or County Equivalent',
        country: 'Country',
        location: 'Were you born in the United States?',
        sub: 'Where were you born?',
        mothersNameAtHerBirth: "What was your mother's name at birth?",
        mothersNameAtYourBirth: 'If your mother used any other names, please provide her name at your time of birth',
      },
    },
    ssn: {
      title: 'Provide your U.S. Social Security Number',
      info: [
        'This section asks for information regarding your U.S. Social Security Number.',
      ],
      heading: {
        verify: 'Please confirm your Social Security Number',
        verified: 'Thank you for confirming your Social Security Number!',
      },
      help: {
        title: 'Check "Not applicable" if no SSN',
        message:
          'If you don’t have a U.S. Social Security Number check the "Not applicable" checkbox, otherwise please enter your Social Security Number.',
        note: '',
      },
      label: {
        notApplicable: 'Not applicable',
        last: '',
        middle: '',
        first: '',
        verify: 'Please verify your Social Security Number',
      },
    },
    othernames: {
      info: [
        'Additional name(s) you provide are used to check for records about you.  Having your additional names will assist investigators using your correct name and identifiers while conducting interviews or record checks for various activities and timeframes related to your background.',
        '* You must include the name on your birth certificate.',
        '* If your name is one alpha character or a string of alpha characters (such as "Z" or "T.J.", where "T." and "J." are not initials for names), check the "Letter(s) Only" box. ',
        '* If you do not have a middle name, check the "No Middle Name" box. ',
        '* If you are a "Jr.," "Sr.," "II," "III", "IV," etc. enter this under Suffix. ',
        '* If you have a hyphenated name, put the entire hyphenated name in the applicable block (for example, if your last name is "Smith-Jones", put "Smith-Jones" in the "Last Name" block.)',
        '* If you only have one name, put it in the "Last Name" block.',
        '* For nicknames and aliases, put them in the "First Name" block and leave the "Last Name" and "Middle Name" blocks blank.',
        '* Make sure the dates you provide for legal name changes (such as due to a marriage, civil union, or partnership; divorce, dissolution of, or annulment; or any other legal name changes) are the same as the dates on the applicable legal documents.',
      ],
      branch: {
        question: 'Have you ever used a different name?',
      },
      collection: {
        summary: {
          title: 'Summary of other names used',
          name: 'Name',
          present: 'Now',
          nodates: 'NA',
          unknown: 'Provide your other name below',
        },
        append: 'Add another name',
        appendTitle: 'Do you have another name to report?',
      },
      heading: {
        name: 'What is the other name?',
        used: 'When did you use this name?',
      },
    },
    contacts: {
      title: 'Provide your contact information',
      info: 'The following contact information is requested in the event we have additional questions for you. If we do, you will receive a call or contact by email. It is recommended for privacy and efficiency you provide a phone number and email address unique to you. Additional phone numbers and email addresses provide more opportunities to contact you when needed. This could minimize any unnecessary delays of your personnel vetting investigation.',
      help: {
        email: {
          title: 'One (1) email address is required',
          message:
            'At least one email address is required for the completion of your background investigation.',
          note: 'Email format example: name@example.com',
        },
        phoneNumber: {
          title: 'Enter only current phone numbers',
          message:
            'Additional numbers provided may assist in the completion of your background investigation.',
          note: '',
        },
        emailType: {
          title: 'Email type',
          message:
            'Select either personal email or work email',
        },
      },
      collection: {
        summary: {
          unknownPhone: 'Provide your telephone number below',
          phoneNumber: 'Phone number',
          unknownEmail: 'Provide your email below',
          email: 'Email',
        },
        phoneNumbers: {
          timeOfDayLabel: 'Best time to call',
          summary: {
            title: 'Summary of phone numbers',
          },
          append: 'Add another phone number',
        },
        emails: {
          summary: {
            title: 'Summary of emails',
          },
          append: 'Add another email',
        },
      },
      heading: {
        email: 'What is your email address? (You may list more than one.)',
        emailHome: 'Home email address',
        emailWork: 'Work email address',
        emailAddress: 'Email address',
        phoneNumber: 'What is your phone number? (You may list more than one)',
      },
      para: {
        email: 'Email addresses may be used as a contact method and a means to identify you.',
        phoneNumber:
          '**At least one telephone number is required**. You are encouraged to enter a phone number of each type (home, cell, work), if applicable. Additional numbers may assist in the completion of your background investigation. No more than one of each phone number type can be provided. If there is a second blank phone number field and you do not have a phone number for it, you can click "remove" to take it out of the form.',
      },
      label: {
        email: 'Email address',
        comments:
          'If you need to provide any additional comments about this information enter them below',
        phoneNumber: 'Phone number',
        emailType: 'Email type'
      },
    },
  },
  intro: {
    title: 'Information about you',
    body:
      'You will be asked questions about your personal information and to provide details if necessary.',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with identification at once',
  },
  section: {
    name: 'Information about you',
  },
  subsection: {
    intro: 'Introduction',
    name: 'Full name',
    birthdate: 'Date of birth',
    birthplace: 'Place of birth',
    ssn: 'Social security number',
    othernames: 'Other names used',
    contacts: 'Your contact information',
    physical: 'Your identifying information',
    review: 'Review',
  },
  destination: {
    intro: 'Identification intro',
    review: 'Review Identification',
    othernames: 'Other names used',
    name: 'Full name',
    birthdate: 'Date of birth',
    birthplace: 'Place of birth',
    contacts: 'Your contact information',
    ssn: 'Social security number',
    physical: 'Your identifying information',
  },
  applicantName: {
    title: 'Provide your full name',
    info:
      'If you have only initials in your name, provide them and indicate “initial only.” If you do not have a middle name, indicate “No Middle Name.” If you are a “Jr”, “Sr”, etc. enter this under "Suffix."',
    last: {
      help: {
        title: 'Enter a valid last name.',
        message:
          'Please enter your entire last name. If your last name is a single letter, select the "Initial only" checkbox and type the letter below.',
        note: '',
      },
    },
    first: {
      help: {
        title: 'Enter a valid first name.',
        message:
          'Please enter your entire first name. If your first name is a single letter, select the "Initial only" checkbox and type the letter below.',
        note: '',
      },
    },
    middle: {
      help: {
        title: 'Enter a valid middle name.',
        message: [
          'Please enter your entire middle name.',
          'If your middle name is a single letter, select the "initial only" checkbox and type the letter below. If you don\'t have a middle name, select the "No middle name" checkbox and leave the field below blank.',
        ],
        note: '',
      },
    },
    suffix: {
      help: {
        title: 'Use "Other" if your suffix isn\'t listed',
        message:
          'If the suffix does not appear in this list, select "Other" and enter the suffix in the provided field.',
        note: '',
      },
    },
  },
  name: {
    title: 'Provide your full name',
    info:
      'If this person only has initials in their name, provide them and indicate “initial only”.  If they do not have a middle name, indicate “No Middle Name”.  If they are a “Jr”, “Sr”, etc. then please enter this under suffix.',
    last: {
      help: {
        title: 'Enter a valid last name.',
        message:
          'Please enter this person\'s entire last name. If this person\'s last name is a single letter, select the "Initial only" checkbox and type the letter below.',
        note: '',
      },
    },
    first: {
      help: {
        title: 'Enter a valid first name.',
        message:
          'Please enter this person\'s entire first name. If this person\'s first name is a single letter, select the "Initial only" checkbox and type the letter below.',
        note: '',
      },
    },
    middle: {
      help: {
        title: 'Enter a valid middle name.',
        message: [
          'Please enter this person\'s entire middle name.',
          'If this person\'s middle name is a single letter, select the "initial only" checkbox and type the letter below. If this person doesn\'t have a middle name, select the "No middle name" checkbox and leave the field below blank.',
        ],
        note: '',
      },
    },
    suffix: {
      help: {
        title: 'Use "Other" if your suffix isn\'t listed',
        message:
          'If the suffix does not appear in this list, select "Other" and enter the suffix in the provided field.',
        note: '',
      },
    },
  },
  othernames: {
    title: 'Provide your other names used and the period of time you used them',
    info:
      'For example: your maiden name, name(s) by a former marriage, former name(s), alias(es), or nickname(s).',
    branch: {
      help: {
        title: 'List all other names you have used no matter how long ago',
        message: [
          'Input names one at a time.  You will have the ability to add multiple other names.',
        ],
        note:
          'Example: Full name is Michael and nickname Mike. "Mike" would be the other name used.',
      },
      question: 'Have you used any other names?',
    },
    collection: {
      summary: {
        title: 'Summary of other names used',
        name: 'Name',
        present: 'Now',
        nodates: 'NA',
        unknown: 'Provide your full name below',
      },
      append: 'Add another name',
      appendTitle: 'Do you have additional names to enter?',
    },
    itemcomment: 'Optional Comment',
    summarycomment: 'Optional Comment',
    comment: 'Optional Comment',
    heading: {
      name: 'Provide other name used',
      maiden: 'Maiden name?',
      used: 'Dates used',
      reason: 'Provide the reasons why the name was changed',
    },
    label: {
      maiden: 'Maiden name?',
      reason: 'Provide the reasons why the name changed',
    },
  },
  birthdate: {
    title: 'Provide your date of birth',
    confirmation: 'I confirm this date is correct',
    help: {
      title: 'Check "Estimated" if date of birth is unknown',
      message:
        'If you are not sure of your exact date of birth estimate it as best you can and check the "Estimated" checkbox. ',
      note: '',
    },
  },
  birthplace: {
    title: 'Provide your place of birth',
    question: {
      label: 'Were you born in the United States of America?',
      yes: 'Yes',
      no: 'No',
    },
    branch: {
      help: {
        title: 'This is your physical place of birth',
        message:
          'Example: United States citizens born in another country would list that other country.',
        note: '',
      },
    },
    help: {
      city: {
        title: 'Need help with the city?',
        message: 'City where you were born',
        note: '',
      },
      state: {
        title: 'Need help with the state?',
        message: 'State where you were born',
        note: '',
      },
      country: {
        title: 'Need help with the country?',
        message: 'Country where you were born',
        note: '',
      },
      county: {
        title: 'Need help with the county?',
        message: 'County where you were born',
        note: '',
      },
    },
    label: {
      state: 'State or territory',
      city: 'City',
      county: 'County or province',
      country: 'Country',
      location: 'Were you born in the United States?',
    },
  },
  contacts: {
    title: 'Provide your contact information',
    help: {
      email: {
        title: 'One (1) email address is required',
        message:
          'Either one work or one personal email address is required for the completion of your background investigation.',
        note: 'Email format example: name@example.com',
      },
      phoneNumber: {
        title: 'Enter only current phone numbers',
        message:
          'Additional numbers provided may assist in the completion of your background investigation.',
        note: '',
      },
    },
    collection: {
      summary: {
        unknownPhone: 'Provide your telephone number below',
        phoneNumber: 'Phone number',
      },
      phoneNumbers: {
        summary: {
          title: 'Summary of phone numbers',
        },
        append: 'Add another phone number',
      },
    },
    heading: {
      email: 'Your email addresses',
      emailHome: 'Home email address',
      emailWork: 'Work email address',
      phoneNumber: 'Your phone numbers',
    },
    para: {
      email: 'Email addresses may be used as a contact method and a means to identify you.',
      phoneNumber:
        '**At least one telephone number is required**. You are encouraged to enter a phone number of each type (home, cell, work), if applicable. Additional numbers may assist in the completion of your background investigation. No more than one of each phone number type can be provided. If there is a second blank phone number field and you do not have a phone number for it, you can click "remove" to take it out of the form.',
    },
    label: {
      email: 'Email address',
      comments:
        'If you need to provide any additional comments about this information enter them below',
      phoneNumber: 'Phone number',
    },
  },
  ssn: {
    title: 'Provide your U.S. Social Security Number',
    heading: {
      verify: 'Please confirm your Social Security Number',
      verified: 'Thank you for confirming your Social Security Number!',
    },
    help: {
      title: 'Check "Not applicable" if no SSN',
      message:
        'If you don’t have a U.S. Social Security Number check the "Not applicable" checkbox, otherwise please enter your Social Security Number.',
      note: '',
    },
    label: {
      notApplicable: 'Not applicable',
      last: '',
      middle: '',
      first: '',
      verify: 'Please verify your Social Security Number',
    },
  },
  traits: {
    title: 'Provide your identifying information',
    heading: {
      hair: 'Hair color',
      eye: 'Eye color',
      height: 'Height',
      weight: 'Weight',
      sex: 'Sex',
    },
    comment: 'Optional Comment',
    help: {
      feet: {
        title: 'Need help with your height?',
        message: 'Feet must be a number between 1 and 9',
        note: '',
      },
      inches: {
        title: 'Need help with your height?',
        message: 'Inches must be a number between 0 and 11',
        note: '',
      },
      height: {
        title: 'Use feet and inches only',
        message: ['Feet must be a number between 1 and 9. Inches must be between 0 and 11.'],
        note: '',
      },
      weight: {
        title: 'Use pounds and whole numbers only',
        message: ['Weight must be a number between 10 and 999.'],
        note: '',
      },
      eye: {
        title: 'Select your natural eye color?',
        message: 'Choose the eye color that most closely represents your eyes.',
        note: '',
      },
      hair: {
        title: 'Select your current hair color or style',
        message: 'Choose the hair color that most closely represents your hair today.',
        note: '',
      },
    },
    label: {
      sex: 'Select your sex at the time of birth',
      feet: 'Feet',
      inches: 'Inches',
      pounds: 'Pounds',
    },
    hair: {
      bald: 'Bald',
      black: 'Black',
      blonde: 'Blonde or strawberry',
      brown: 'Brown',
      gray: 'Gray or partially gray',
      red: 'Red or auburn',
      sandy: 'Sandy',
      white: 'White',
      blue: 'Blue',
      green: 'Green',
      orange: 'Orange',
      pink: 'Pink',
      purple: 'Purple',
      unknown: 'Unspecified or unknown',
    },
    eye: {
      black: 'Black',
      blue: 'Blue',
      brown: 'Brown',
      gray: 'Gray',
      green: 'Green',
      hazel: 'Hazel',
      maroon: 'Maroon',
      multi: 'Multicolored',
      pink: 'Pink',
      unknown: 'Unknown',
    },
    sex: {
      female: 'Female',
      male: 'Male',
    },
  },
};
